module.exports = __webpack_public_path__ + "static/media/queue.3cdfb8d9.png";